<template>
  <modal
    :name="modalId"
    :scrollable="true"
    width="60%"
    height="auto"
    @closed="handleClose"
  >
    <div class="modal-content">
      <div class="modal-header">
        <h3 style="margin-bottom: 5px; color: #fff"> {{ label }} Quote </h3>
        <div style="color: #fff">
          {{ contractor.attributes.first_name }}
          {{ contractor.attributes.last_name }}
        </div>
      </div>
      <div class="modal-body">
        <p
          >Your contact info will be sent to
          {{ contractor.attributes.first_name }}
          {{ contractor.attributes.last_name }}, who is one of our trusted and
          <recommended-contractors-title lower-case />.</p
        >
        <form @submit.prevent="handleSubmit">
          <div
            class="vpx-1"
            style="
              background: #fef2f2;
              border: 1px solid #ef4444;
              color: #b91c1c;
              margin-bottom: 20px;
            "
            v-if="hasErrors"
          >
            <div style="padding: 7px" :key="error" v-for="error in errors">
              {{ error }}
            </div>
          </div>
          <v-layout wrap>
            <v-flex md6 xs12 vpx-1>
              <v-text-field label="First Name" v-model="form.first_name" />
            </v-flex>
            <v-flex md6 xs12 vpx-1>
              <v-text-field label="Last Name" v-model="form.last_name" />
            </v-flex>
            <v-flex md6 xs12 vpx-1>
              <v-text-field label="Email" v-model="form.email" />
            </v-flex>
            <v-flex md6 xs12 vpx-1>
              <v-text-field label="Phone" v-model="form.phone" />
            </v-flex>
          </v-layout>
          <div style="margin-top: 20px">
            <h4 style="margin-bottom: 5px; text-align: left">
              {{ observationLabel }} to include in quote
            </h4>
            <div class="light"
              >The text and photos will automatically be added to the quote
              request.</div
            >
          </div>
          <v-layout :key="observation.id" v-for="observation in observations">
            <v-flex xs12>
              <v-checkbox
                v-model="form.observations"
                :value="observation.id"
                hide-details
              >
                <template slot="label">
                  <span v-if="observation.attributes.report_item">
                    {{
                      observation.attributes.report_item.attributes.name
                    }}&nbsp;-&nbsp;
                  </span>
                  <span>
                    {{ observation.attributes.name }}
                  </span>
                </template>
              </v-checkbox>
            </v-flex>
          </v-layout>
          <v-layout wrap>
            <v-flex md12 vpx-1 style="margin-top: 20px">
              <v-textarea
                label="Message"
                v-model="form.details"
                rows="2"
                placeholder="Add an optional message..."
              />
            </v-flex>
          </v-layout>
          <div
            class="right-align"
            style="margin-top: 20px; margin-bottom: 10px"
          >
            <span
              class="fg-warning"
              style="display: inline-block; margin-right: 5px"
              v-if="hasErrors"
            >
              There was an error. See above.
            </span>
            <v-btn flat @click="handleClose">Cancel</v-btn>
            <v-btn type="submit" color="primary">Send</v-btn>
          </div>
        </form>
      </div>
    </div>
  </modal>
</template>

<script>
import RecommendedContractorsTitle from '../recommended_contractors/RecommendedContractorsTitle.vue'
import { postContractorLead } from '@/api'

export default {
  components: {
    RecommendedContractorsTitle,
  },
  props: {
    buyer: {
      type: Object,
      default: () => ({}),
    },
    contractor: {
      type: Object,
      default: () => ({}),
    },
    initialValues: {
      type: Object,
      default: () => ({}),
    },
    reportId: {
      type: String,
      default: null,
    },
    inspectionId: {
      type: Number,
      default: null,
    },
  },

  data() {
    const buyerAttributes = (this.buyer && this.buyer.attributes) || {}
    const observations = this.contractor.observations.map(
      (observation) => observation.id
    )

    const form = {
      contractor_type: this.contractor.contractorType.id,
      details: '',
      first_name: buyerAttributes.first_name || '',
      last_name: buyerAttributes.last_name || '',
      email: buyerAttributes.email || '',
      phone: buyerAttributes.phone || '',
      observations,
      ...this.initialValues,
    }

    return {
      modalId: 'contractor-form-modal',
      errors: [],
      form,
    }
  },

  computed: {
    contractorType() {
      return this.contractor.contractorType || {}
    },

    hasErrors() {
      return this.errors.length > 0
    },

    label() {
      return this.contractorType.name || ''
    },

    observations() {
      return this.contractor.observations || []
    },

    observationLabel() {
      return this.contractor.observationLabel || []
    },
  },

  methods: {
    async handleSubmit() {
      this.errors = []

      if (this.form.first_name === '') {
        this.errors.push('First name is required')
        return
      }
      if (this.form.last_name === '') {
        this.errors.push('Last name is required')
        return
      }
      if (this.form.email === '') {
        this.errors.push('Email is required')
        return
      }
      if (this.form.phone === '') {
        this.errors.push('Phone number is required')
        return
      }

      const whitelist = this.form.observations.map((selectedObservationId) => {
        const observation =
          this.contractor.observations.find(
            (observation) => observation.id === selectedObservationId
          ) || {}

        return {
          observation_id: observation.id,
          number: observation.number,
        }
      })

      const params = {
        report_view: {
          report_id: this.reportId,
          whitelist,
        },
        upsell_lead: {
          ...this.form,
          company_contractor_id: this.contractor.id,
          contractor_type: this.contractorType.id,
          report_id: this.reportId,
        },
      }

      const resp = await postContractorLead(params)

      this.$emit('submitted', resp)
      this.handleClose()
    },

    handleClose() {
      this.$emit('closed')
      this.$modal.hide(this.modalId)
    },
  },

  mounted() {
    this.$modal.show(this.modalId)
  },
}
</script>

<style></style>
